import { render, staticRenderFns } from "./ConsumerProgramsExplorer.vue?vue&type=template&id=bfb7fbcc&scoped=true&"
import script from "./ConsumerProgramsExplorer.vue?vue&type=script&lang=js&"
export * from "./ConsumerProgramsExplorer.vue?vue&type=script&lang=js&"
import style0 from "./ConsumerProgramsExplorer.vue?vue&type=style&index=0&id=bfb7fbcc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfb7fbcc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VRow})
